module.exports = __webpack_public_path__ + "assets/newsletter-arrow.c27b5c00.svg";